import { apiBaseUrl } from "../config/api";
import { clearToken, getToken } from "./tokenStorage";

async function parseResponse(response) {
  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json") ? await response.json() : await response.text();

  if (!response.ok) {
    const message = typeof data === "object" && data?.message ? data.message : "Požadavek se nepodařil.";
    if (response.status === 401) {
      clearToken();
      window.dispatchEvent(new Event("eltt:auth-expired"));
    }
    throw new Error(message);
  }

  return data;
}

export async function apiRequest(path, options = {}) {
  const token = getToken();
  const headers = {
    Accept: "application/json",
    ...(options.body ? { "Content-Type": "application/json" } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });

  return parseResponse(response);
}
